export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    
  ]
}
